var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.907.99c1.16 0 2.1.94 2.1 2.1v.913h4.19v1.2h-1.19V16.89c0 1.11-.86 2.018-1.95 2.095l-.15.005h-7.84c-1.16 0-2.1-.94-2.1-2.1V5.203H2.802v-1.2h4.201V3.09c0-1.11.86-2.018 1.95-2.095l.15-.005zm3.9 4.213h-9.64V16.89c0 .459.344.837.788.893l.113.007h7.84c.497 0 .9-.403.9-.9V5.203zM8.8 8.195v7.195H7.6V8.195h1.2zm3.619 0v7.195h-1.2V8.195h1.2zM10.907 2.19H9.104c-.497 0-.9.403-.9.9v.913h3.602V3.09c0-.459-.342-.837-.786-.893l-.113-.007z",
    transform: "translate(-898 -575) translate(898 575)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDelete);
export default __webpack_public_path__ + "static/media/icons-delete.eacdb3c7.svg";
export { ForwardRef as ReactComponent };